var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStampplaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "265px",
    height: "229px",
    viewBox: "0 0 265 229",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "stampplaceholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stampplaceholder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fillOpacity: 0.372732736,
    fill: "#B8B1B1",
    x: 11.5,
    y: 11,
    width: 242,
    height: 207
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    x: 41,
    y: 88.5,
    width: 182,
    height: 46
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    x: 0,
    y: 0.5,
    width: 6,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    transform: "translate(29.500000, 3.000000) rotate(90.000000) translate(-29.500000, -3.000000) ",
    x: 26.5,
    y: -26,
    width: 6,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    x: 259,
    y: 0.5,
    width: 6,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    transform: "translate(235.500000, 3.000000) rotate(90.000000) translate(-235.500000, -3.000000) ",
    x: 232.5,
    y: -26,
    width: 6,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    x: 0,
    y: 170.5,
    width: 6,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    transform: "translate(29.500000, 226.000000) rotate(90.000000) translate(-29.500000, -226.000000) ",
    x: 26.5,
    y: 197,
    width: 6,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    x: 259,
    y: 170.5,
    width: 6,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E3B92C",
    transform: "translate(235.500000, 226.000000) rotate(90.000000) translate(-235.500000, -226.000000) ",
    x: 232.5,
    y: 197,
    width: 6,
    height: 58
  }), /*#__PURE__*/React.createElement("text", {
    id: "Stamp-Placeholder",
    fontFamily: "ProximaNova-Light, Proxima Nova",
    fontSize: 16,
    fontWeight: 300,
    "line-spacing": 32,
    letterSpacing: -0.203174667,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 73,
    y: 111.5
  }, "Stamp Placeholder"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampplaceholder);
export default __webpack_public_path__ + "static/media/stampplaceholder.c561771ad203cd4c543a9d4062334857.svg";
export { ForwardRef as ReactComponent };